module.exports = __webpack_public_path__ + "img/2024-07-01d_3.f05a9fd8.jpg";